// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Stdlib_Int = require("@rescript/runtime/lib/js/Stdlib_Int.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let Primitive_string = require("@rescript/runtime/lib/js/Primitive_string.js");
let RescriptReactRouter = require("@rescript/react/src/RescriptReactRouter.bs.js");

function bool(params, key) {
  let match = params.get(key);
  if (match == null) {
    return;
  }
  switch (match) {
    case "false" :
      return false;
    case "true" :
      return true;
    default:
      return;
  }
}

function stringArrNonEmpty(params, key) {
  let v = params.getAll(key);
  if (v.length !== 0) {
    return v;
  }
}

function int(params, key) {
  return Stdlib_Option.flatMap(Primitive_option.fromNullable(params.get(key)), v => Stdlib_Int.fromString(v, undefined));
}

function string(prim0, prim1) {
  return Primitive_option.fromNullable(prim0.get(prim1));
}

function setIfExists(searchParams, key, v, toString) {
  if (v !== undefined) {
    searchParams.set(key, toString(Primitive_option.valFromOption(v)));
  } else {
    searchParams.delete(key);
  }
}

function setIfExistsInt(none, none$1, none$2) {
  return setIfExists(none, none$1, none$2, v => v.toString());
}

function setIfExistsBool(none, none$1, none$2) {
  return setIfExists(none, none$1, none$2, v => {
    if (v) {
      return "true";
    } else {
      return "false";
    }
  });
}

function setIfExistsArr(searchParams, key, v, toString) {
  if (v !== undefined) {
    v.forEach(c => {
      searchParams.append(key, toString(c));
    });
  } else {
    searchParams.delete(key);
  }
}

function setIfExistsArrStr(none, none$1, none$2) {
  return setIfExistsArr(none, none$1, none$2, v => v);
}

function sortAndDeduplicate(values, toString) {
  let sorted = values.slice();
  sorted.sort((left, right) => Primitive_string.compare(toString(left), toString(right)));
  return Stdlib_Array.reduce(sorted, [], (unique, value) => {
    let previous = unique[unique.length - 1 | 0];
    if (previous !== undefined) {
      if (toString(Primitive_option.valFromOption(previous)) === toString(value)) {
        return unique;
      } else {
        return unique.concat([value]);
      }
    } else {
      return unique.concat([value]);
    }
  });
}

function setQueryParamsInURL(paramsToUrl, toParams, fromUrl, modeOpt, updater) {
  let mode = modeOpt !== undefined ? modeOpt : "replace";
  let location = window.location;
  let newUrl = paramsToUrl(updater(toParams(fromUrl(new URLSearchParams(location.search)))));
  if (mode === "replace") {
    return RescriptReactRouter.replace(newUrl);
  } else {
    return RescriptReactRouter.push(newUrl);
  }
}

function use(fromUrl, toParams, setQueryParamsInURL) {
  let params = toParams(fromUrl(new URLSearchParams(RescriptReactRouter.useUrl(undefined, undefined).search)));
  return [
    params,
    setQueryParamsInURL
  ];
}

function getCurrentParams(fromUrl, toParams) {
  let location = window.location;
  return toParams(fromUrl(new URLSearchParams(location.search)));
}

let URLHelpers = {
  setQueryParamsInURL: setQueryParamsInURL,
  use: use,
  getCurrentParams: getCurrentParams
};

exports.bool = bool;
exports.stringArrNonEmpty = stringArrNonEmpty;
exports.int = int;
exports.string = string;
exports.setIfExists = setIfExists;
exports.setIfExistsInt = setIfExistsInt;
exports.setIfExistsBool = setIfExistsBool;
exports.setIfExistsArr = setIfExistsArr;
exports.setIfExistsArrStr = setIfExistsArrStr;
exports.sortAndDeduplicate = sortAndDeduplicate;
exports.URLHelpers = URLHelpers;
/* RescriptReactRouter Not a pure module */
